import useGetEvents from "@/hooks/api/events/useGetEvents"
import { Box, Divider, Typography } from "@mui/material"
import EventCard from "./EventCard"
import { Event } from "@/common/types"
import dayjs from "dayjs"

const ViewEvents = () => {
  const { data: events, isLoading } = useGetEvents()

  if (isLoading) {
    return (
      <>
        <Typography>Loading</Typography>
      </>
    )
  }
  return (
    <>
      <Box p={2}>
        <Typography variant="h3">Upcoming</Typography>
        <Divider sx={{ p: 1 }} />
        {events.data.map((event: Event) => {
          if (dayjs(event.event_start_timestamp).isAfter(dayjs())) {
            return <EventCard key={event.event_id} event={event} />
          }
        })}
      </Box>
      <Box p={2}>
        <Typography variant="h3">Previous</Typography>
        <Divider sx={{ p: 1 }} />
        {events.data.map((event: Event) => {
          if (dayjs(event.event_start_timestamp).isBefore(dayjs())) {
            return <EventCard key={event.event_id} event={event} />
          }
        })}
      </Box>
    </>
  )
}

export default ViewEvents
